import styled from "styled-components";
import {MEDIA} from "@brg/ui";
import {Colors, FlexBox} from "@brg/ui";
import { css } from "styled-components";

export const VotingRatingTitle = styled.div<{color?: string}>`
  color: ${({color}) => color};
  font-family: Inter;
  font-size: 60px;
  font-style: normal;
  font-weight: 600;
  line-height: 70px;
  letter-spacing: -0.02em;
  text-transform: lowercase;
  margin-bottom: 32px;

  @media ${MEDIA.TABLET} {
    font-size: 43px;
    line-height: 51px;
    margin-bottom: 24px;
  }
  @media ${MEDIA.MOBILE} {
    font-size: 22px;
    line-height: 28px;
  }
`


export const VotingRatingTab = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 32px;
  margin-bottom: 24px;

  @media ${MEDIA.TABLET} {
    margin-top: 24px;
    margin-bottom: 16px;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    line-height: 16px;
  }
  @media ${MEDIA.MOBILE} {
    margin-top: 16px;
  }
`

export const VotingCard = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 32px;
  margin-bottom: 24px;

  @media ${MEDIA.TABLET} {
    margin-top: 24px;
    margin-bottom: 16px;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    line-height: 16px;
  }
  @media ${MEDIA.MOBILE} {
    margin-top: 16px;
  }
`
import styled from "styled-components";
import {MEDIA} from "@brg/ui";
import {Colors, FlexBox} from "@brg/ui";
import { css } from "styled-components";

export const VotingRatingTitle = styled.div<{color?: string}>`
  color: ${({color}) => color};
  font-family: Inter;
  font-size: 60px;
  font-style: normal;
  font-weight: 600;
  line-height: 70px;
  letter-spacing: -0.02em;
  text-transform: lowercase;
  margin-bottom: 32px;

  @media ${MEDIA.TABLET} {
    font-size: 43px;
    line-height: 51px;
    margin-bottom: 24px;
  }
  @media ${MEDIA.MOBILE} {
    font-size: 22px;
    line-height: 28px;
  }
`


export const VotingRatingTab = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 32px;
  margin-bottom: 24px;

  @media ${MEDIA.TABLET} {
    margin-top: 24px;
    margin-bottom: 16px;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    line-height: 16px;
  }
  @media ${MEDIA.MOBILE} {
    margin-top: 16px;
  }
`

export const VotingCard = styled.div`
  color: ${Colors.galBlack47};
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 32px;
  margin-bottom: 24px;

  @media ${MEDIA.TABLET} {
    margin-top: 24px;
    margin-bottom: 16px;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    line-height: 16px;
  }
  @media ${MEDIA.MOBILE} {
    margin-top: 16px;
  }
`
